import { safeCombineEpics } from '@cbridge-utils/redux-observable';
import { loadSymbolClientListEpic } from './_epic/loadSymbolClientList.epic';
import { loadSymbolClientListFromServerEpic } from './_epic/loadSymbolClientListFromServer.epic';
import { loadSymbolClientCountersEpic } from './_epic/loadSymbolClientCounters.epic';
import { reloadSymbolClientCountersEpic } from './_epic/reloadSymbolClientCounters.epic';
import { startSymbolClientProcessingEpic } from './_epic/startSymbolClientProcessing.epic';
import { endSymbolClientProcessingEpic } from './_epic/endSymbolClientProcessing.epic';
import { createSymbolClientEpic } from './_epic/createSymbolClient.epic';
import { updateSymbolClientEpic } from './_epic/updateSymbolClient.epic';
import { removeSymbolClientEpic } from './_epic/removeSymbolClient.epic';
import { loadSymbolClientEpic } from './_epic/loadSymbolClient.epic';
import { exportClientSymbolsEpic } from './_epic/exportClientSymbols.epic';
import { bulkRemoveSymbolClientEpic } from './_epic/bulkRemoveSymbolClient.epic';

export const symbolClientEpic = safeCombineEpics(
  loadSymbolClientListEpic,
  loadSymbolClientListFromServerEpic,
  loadSymbolClientCountersEpic,
  reloadSymbolClientCountersEpic,
  startSymbolClientProcessingEpic,
  endSymbolClientProcessingEpic,
  createSymbolClientEpic,
  updateSymbolClientEpic,
  removeSymbolClientEpic,
  loadSymbolClientEpic,
  exportClientSymbolsEpic,
  bulkRemoveSymbolClientEpic,
);
